export default __webpack_public_path__ + "static/media/page7.295ec901.png";